module.exports = __webpack_public_path__ + "img/toast-close 2.0ff70821.svg";